import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { Field, SelectInput } from '@hb/coffee';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { isEmptyFieldValue } from '../../utils';

@Component({ name: 'Registration' })
export default class Registration extends Vue {
  @Prop()
  private value!: number | undefined;

  /** 户籍性质 */
  private registration: number | undefined | null = null;

  private options: OptionItem[] = [];

  private errorMsg = '';

  private async created() {
    if (this.value) {
      this.registration = this.value;
    }

    this.options = await DictApi.getRegistration();
  }

  @Watch('value')
  private onPropsValueChange(val: undefined | number) {
    this.registration = val;
  }

  public onValidator(): boolean {
    if (isEmptyFieldValue(this.registration)) {
      this.errorMsg = '请选择户籍性质';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChangeRegistration(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field
        label="户籍性质"
        errorMessage={this.errorMsg}
      >
        <SelectInput
          v-model={this.registration}
          title="选择户籍性质"
          placeholder="选择户籍性质"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeRegistration}
        />
    </Field>
    );
  }
}
